import React, { FC } from 'react'

import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { EmptyTileElem } from './styles'

export const EmptyTile: FC = () => {
  const { t } = useCommonTranslation()
  return (
    <EmptyTileElem className="slider__item empty__item">
      <span>{t('noEvents')}</span>
    </EmptyTileElem>
  )
}
